export default {
  notPossible: 'Ručný presun nie je možný',
  executedConfirm: 'Je presun z "{source}" do "{target}" vykonaný?',
  command: {
    accept: 'Prijať príkaz',
    ack: 'Potvrdiť',
  },
};
